import React from "react";

const ProjectsSection = ({
  projectsRef,
  showProjects,
  projects,
  projectSlideIndex,
  nextProjectSlide,
  prevProjectSlide,
  isSliding,
  slideDirection,
}) => {
  return (
    <section ref={projectsRef} className="bg-white py-5 position-relative">
      {/* NEW WRAPPER */}
      <div className="project-animation-wrapper">
        <div
          className="container position-relative"
          style={{
            opacity: showProjects ? 1 : 0,
            transform: showProjects ? "translateX(0)" : "translateX(100px)",
            transition: "all 1s ease-out",
          }}
        >
          <h2 className="fw-bold text-center mb-5" style={{ color: "#011601" }}>
            Our Projects
          </h2>

          <div className="position-relative project-slider-wrapper">
            {/* Arrow Buttons */}
            <button
              onClick={prevProjectSlide}
              className="project-arrow position-absolute top-50 start-0 border-0 rounded-circle shadow"
              style={{ transform: "translateY(-50%)" }}
            >
              <i className="bi bi-chevron-left text-white"></i>
            </button>

            <button
              onClick={nextProjectSlide}
              className="project-arrow position-absolute top-50 end-0 border-0 rounded-circle shadow"
              style={{ transform: "translateY(-50%)" }}
            >
              <i className="bi bi-chevron-right text-white"></i>
            </button>

            <div className="row justify-content-center">
              {projects
                ?.slice(projectSlideIndex, projectSlideIndex + 3)
                .map((item, i) => (
                  <div
                    key={`${projectSlideIndex}-${i}`}
                    className="col-12 col-md-4 mb-4 d-flex justify-content-center"
                  >
                    <div
                      className={`card-slide shadow-sm ${
                        isSliding
                          ? slideDirection === "left"
                            ? "slide-left"
                            : "slide-right"
                          : ""
                      }`}
                    >
                      <h5
                        className="mb-3 fw-bold text-center"
                        style={{ flexShrink: 0 }}
                      >
                        {item.descriptions}
                      </h5>
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ flexShrink: 0, marginBottom: "12px" }}
                      >
                        <div className="card-content">
                          <img
                            className="card-image"
                            src={item.logo}
                            alt={`Icon ${i}`}
                          />
                        </div>
                        <span style={{ marginLeft: "8px" }}>{item.name}</span>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
